import Button from 'react-bootstrap/Button';
import React from 'react'
import {
    Link,
  } from "react-router-dom";
import Table from 'react-bootstrap/Table';
import Carousel from 'react-bootstrap/Carousel';

import { useNavigate } from 'react-router-dom';

export const Main = (props) => {

  const navigate = useNavigate();

    return (
        <div>
        <div style={{paddingTop: 36}}>
        {/* <div id="carouselExampleIndicators" className="carousel slide d-none d-md-block" style={{marginTop: 16}} data-ride="carousel">
          <ol className="carousel-indicators">
            <li data-target="#carouselExampleIndicators" data-slide-to="0" className="active"></li>
            <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
            
          </ol>
          <div className="carousel-inner" role="listbox">
            <div className="carousel-item active" style={{backgroundColor: 'lightgray',  backgroundImage: "url('/images/output-onlinepngtools.png')"}}>
              <div className="carousel-caption d-none d-md-block">
                <h3>Advanced POS Software</h3>
                <p>Wholesale/Retail POS Software.</p>
              </div>
            </div>
            <div className="carousel-item" style={{backgroundColor: 'lightgray',  backgroundImage: "url('/images/altriaqb.png')"}}>
              <div className="carousel-caption d-none d-md-block">
                <h3>MSA Reporting for Quickbooks</h3>
                <p>STARS MSA Multicat tobacco data reporting</p>
              </div>
            </div>
          
          </div>
          <a className="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="sr-only">Previous</span>
          </a>
          <a className="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="sr-only">Next</span>
          </a>
        </div> */}
      </div>


      <div className="container">

        <div id="brand-div" className="row" style={{marginTop: 18}}>
          <div className="col-lg-6 mb-4">
            <div className="card h-100" style={{textAlign: 'left', padding: 16}}>
              <h1 style={{fontFamily: 'effraReg', fontSize: '3.5rem'}}>Built for distributors.</h1>
              <h1 style={{fontFamily: 'effraReg', fontSize: '3.5rem'}}>Built for retailers.</h1>
              <h1 style={{fontFamily: 'effraReg', fontSize: '3.5rem'}}>Built for you.</h1>
              <div className="card-body" style={{padding: 0, paddingBottom: 16, paddingTop: 20}}>
                <p className="card-text" style={{textAlign: 'left', fontFamily: 'effraReg', fontSize: '1rem'}}>Flexible, simple and powerful point of sale software suitable for distributors and retailers.</p>
                <p className="card-text" style={{textAlign: 'left', fontFamily: 'effraReg', fontSize: '1rem'}}>BronzeTag POS will make running your business easier than ever.</p>
              </div>

              <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: 240}}>
                <Button onClick={() => navigate('registeraccount')} variant="primary">Try it for free</Button>
                {/* <Button href="#" variant="primary">See Pricing</Button> */}
              </div>
              
            </div>
          </div>
          <div className="col-lg-6 mb-4">
            <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', alignContent: 'center', maxHeight: 300}}>
              <div className="row">
              
                    <img
                      style={{width: 163, height: 213}}
                      src="/images/Secure.png"
                      alt="Mobile App"
                    />
              
                {/* <img
                  style={{width: 163, height: 213}}
                  src="/images/Secure.png"
                  alt="Mobile App"
                /> */}
            </div>
            <div className="row" style={{alignItems: 'center'}}>
                <span style={{fontFamily: 'effraReg', fontSize: '1rem', marginTop: 6}}>@BronzeTag we take security very seriously</span>
            </div>
            <Link to={'security'}>Learn More</Link>
            </div>
          </div>
          
          
          
        </div>


        <div class="row d-block">
         <div className="col-12 mb-4">
            <h3 style={{color: '#333333', fontFamily: 'effraReg'}}>Sell in person, </h3>
          </div>
          <div className="col-12 mb-4">
          <p style={{color: '#333333', fontFamily: 'effraReg'}}>with our advanced touch POS system or tabular invoice entry screen</p>
          </div>
          <div className="col-12 mb-4">
            <img
                className="tablet-image"
                src="/images/touchpos3.png"
                alt="First slide"
              />
          </div>
         
        </div>

        <div class="row d-block">
         <div className="col-12 mb-4">
         <h3 style={{color: '#333333', fontFamily: 'effraReg'}}>... or via our Mobile App, </h3>
                  
          </div>
          <div className="col-12 mb-4">
          <p style={{color: '#333333', fontFamily: 'effraReg'}}>giving your customers the flexibility to shop your store with their smart phones</p>
          </div>
          <div className="col-12 mb-4">
          <img
                  className="mobile-image"
                  src="/images/mobile-app-3.png"
                  alt="Mobile App"
                />
          </div>
         
        </div>


        <div class="row d-block">
         <div className="col-12 mb-4">
            <h3 style={{color: '#333333', fontFamily: 'effraReg'}}>... or on the Web</h3>
          </div>
          <div className="col-12 mb-4">
            <p style={{color: '#333333', fontFamily: 'effraReg'}}>with one common inventory and customer data repository</p>
          </div>
          <div className="col-12 mb-4">
            <img
                    className="web-image"
                    src="/images/web-lcd.png"
                    alt="First slide"
                  />
          </div>
        </div>
        
        
        <div className="row" style={{marginTop: 28}}>
          <div className="col-lg-4 mb-4">
            <div className="card h-100">
              <h4 className="card-header">In store sales</h4>
              <div className="card-body">
                <p className="card-text">Advanced cash register software for distributors and retailers.</p>
              </div>
              <div className="card-footer">
              <Link to={'pos'}>Learn More</Link>
                {/* <a href="possoftware.html" className="btn btn-primary">Learn More</a> */}
              </div>
            </div>
          </div>
          <div className="col-lg-4 mb-4">
            <div className="card h-100">
              <h4 className="card-header">Online store</h4>
              <div className="card-body">
                <p className="card-text">Sell online while managing a unified customer and inventory base. </p>
              </div>
              <div className="card-footer">
                <Link to={'online'}>Learn More</Link>
                {/* <a href="onlineorders.html" className="btn btn-primary">Learn More</a> */}
              </div>
            </div>
          </div>
          <div className="col-lg-4 mb-4">
            <div className="card h-100">
              <h4 className="card-header">Reporting</h4>
              <div className="card-body">
                <p className="card-text">We offer a full suit of standard reports and custom reports including MULTICAT Format for MSA 'TOB' Reporting. </p>
              </div>
              <div className="card-footer">
                <Link to={'reports'}>Learn More</Link>
                {/* <a href="onlineorders.html" className="btn btn-primary">Learn More</a> */}
              </div>
            </div>
          </div>
          <div className="col-lg-4 mb-4">
            <div className="card h-100">
              <h4 className="card-header">Inventory Management</h4>
              <div className="card-body">
                <p className="card-text">Manage your inventory across multiple locations and get notified when inventory levels are low</p>
              </div>
              <div className="card-footer">
                <Link to={'inventory'}>Learn More</Link>
                {/* <a href="onlineorders.html" className="btn btn-primary">Learn More</a> */}
              </div>
            </div>
          </div>
          <div className="col-lg-4 mb-4">
            <div className="card h-100">
              <h4 className="card-header">CRM</h4>
              <div className="card-body">
                <p className="card-text">BronzeTag POS can help your business improve customer relationships, increase sales and steamline processes.</p>
              </div>
              <div className="card-footer">
                <Link to={'crm'}>Learn More</Link>
                {/* <a href="onlineorders.html" className="btn btn-primary">Learn More</a> */}
              </div>
            </div>
          </div>
          <div className="col-lg-4 mb-4">
            <div className="card h-100">
              <h4 className="card-header">Vendors and Purchases</h4>
              <div className="card-body">
                <p className="card-text">Manage your vendors and purchase orders in one place.</p>
              </div>
              <div className="card-footer">
                <Link to={'vendors'}>Learn More</Link>
                {/* <a href="onlineorders.html" className="btn btn-primary">Learn More</a> */}
              </div>
            </div>
          </div>
          {/* <div className="col-lg-4 mb-4">
            <div className="card h-100">
              <h4 className="card-header">Multicat for Quickbooks</h4>
              <div className="card-body">
                <p className="card-text">Multicat for Quickbooks integrates with your Quickbooks desktop software and allows a distributor to quickly begin reporting cigarette movement in the format necessary to satisfy the requirements of all the major cigarette manufacturers (MSA reporting).</p>
              </div>
              <div className="card-footer">
                <Link to={'multicat'}>Learn More</Link>
                
              </div>
            </div>
          </div> */}
          
        </div>



        
        
        <hr/>

        

      </div>
      </div>
    )
}